import React from "react";

const Footer = () => {
	return (
		<div>
			<footer
				className="w-100 bg-light text-center"
				style={{ position: "fixed", overflow:"hidden",bottom:"0",left:"0"}}
			>
				{/*<p>
						<img src={instagram} alt="" />
						@techeon2k21 <img src={facebook} alt="" />
						cbitmcatecheon
					</p>*/}
				<p>🤓All Rights Reserved In Terms and Conditions(Saikiran)</p>
			</footer>
		</div>
	);
};

export default Footer;
